import { render, staticRenderFns } from "./DeliveryRecap.vue?vue&type=template&id=fb9b9b0e"
import script from "./DeliveryRecap.vue?vue&type=script&lang=ts"
export * from "./DeliveryRecap.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryRecap.vue?vue&type=style&index=0&id=fb9b9b0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports